module.exports = __webpack_public_path__ + "static/img/7.61e7d6c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/7.png
// module id = 3JBo
// module chunks = 0